module.exports = __webpack_public_path__ + "static/media/gat_symbol_animate.837bc86e.svg";